var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["contentful/ugc-display-tile-content.j2"] = require( "contentful/ugc-display-tile-content.j2" );
dependencies["badges/heart.j2"] = require( "badges/heart.j2" );
dependencies["contentful/ugc-heart.j2"] = require( "contentful/ugc-heart.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/ugc-expanded-tile.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
var t_1;
t_1 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ugc")),"tray")),"clickedTileIndex") - 1;
frame.set("clickedTileIndex", t_1, true);
if(frame.topLevel) {
context.setVariable("clickedTileIndex", t_1);
}
if(frame.topLevel) {
context.addExport("clickedTileIndex", t_1);
}
output += "\n\n";
var t_2;
t_2 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ugc")),"items")),runtime.contextOrFrameLookup(context, frame, "clickedTileIndex"));
frame.set("displayTile", t_2, true);
if(frame.topLevel) {
context.setVariable("displayTile", t_2);
}
if(frame.topLevel) {
context.addExport("displayTile", t_2);
}
output += "\n";
var t_3;
t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ugc")),"isEngage");
frame.set("isEngage", t_3, true);
if(frame.topLevel) {
context.setVariable("isEngage", t_3);
}
if(frame.topLevel) {
context.addExport("isEngage", t_3);
}
output += "\n\n";
var t_4;
t_4 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "displayTile")),"photo")),"large_square")),"url");
frame.set("largePhotoUrl", t_4, true);
if(frame.topLevel) {
context.setVariable("largePhotoUrl", t_4);
}
if(frame.topLevel) {
context.addExport("largePhotoUrl", t_4);
}
output += "\n";
var t_5;
t_5 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "displayTile")),"user");
frame.set("user", t_5, true);
if(frame.topLevel) {
context.setVariable("user", t_5);
}
if(frame.topLevel) {
context.addExport("user", t_5);
}
output += "\n";
var t_6;
t_6 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"small_square")),"url");
frame.set("thumbnailPhotoUrl", t_6, true);
if(frame.topLevel) {
context.setVariable("thumbnailPhotoUrl", t_6);
}
if(frame.topLevel) {
context.addExport("thumbnailPhotoUrl", t_6);
}
output += "\n\n<div class=\"c-ugc-tray__image-outer js-ugc-tray-image-container\" data-pic-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "displayTile")),"id"), env.opts.autoescape);
output += "\">\n\n    ";
env.getTemplate("contentful/ugc-display-tile-content.j2", false, "core/templates/contentful/ugc-expanded-tile.j2", null, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
t_7.render(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
output += t_8
output += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "isEngage")) {
output += "\n\n        <span class=\"c-product-heart-container js-favorite-toggle\">\n\n                <span class=\"c-product-heart-container__count\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "displayTile")),"like_count"), env.opts.autoescape);
output += "</span>\n\n            ";
var t_11;
t_11 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "ugc")),"displayHearts");
frame.set("displayHearts", t_11, true);
if(frame.topLevel) {
context.setVariable("displayHearts", t_11);
}
if(frame.topLevel) {
context.addExport("displayHearts", t_11);
}
output += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "displayHearts")) {
output += "\n\n                <span class=\"c-product-heart-container__icon js-heart-toggle ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"hearted")) {
output += "is-hearted ";
;
}
output += "\">\n\n                    ";
env.getTemplate("badges/heart.j2", false, "core/templates/contentful/ugc-expanded-tile.j2", null, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
t_12.render(context.getVariables(), frame, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
output += t_13
output += "\n\n                </span>\n\n            ";
})});
}
output += "\n\n        </span>\n\n\n    ";
;
}
output += "\n</div>\n\n\n<div class=\"c-ugc-tray__info\">\n\n    <img src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "thumbnailPhotoUrl"), env.opts.autoescape);
output += "\" class=\"c-ugc-tray__avatar\" />\n\n    <span class=\"c-ugc-tray__info-text\">\n        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "user")),"username"), env.opts.autoescape);
output += "\n    </span>\n\n    <span class=\"c-ugc-tray__heart\">";
env.getTemplate("contentful/ugc-heart.j2", false, "core/templates/contentful/ugc-expanded-tile.j2", null, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
t_16.render(context.getVariables(), frame, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
output += t_17
output += "</span>\n\n    <span class=\"c-ugc-tray__like-count\">\n        ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "displayTile")),"like_count"), env.opts.autoescape);
output += "\n    </span>\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "isEngage")) {
output += "\n        <span class=\"c-ugc-tray__comment-count\">\n            ";
output += runtime.suppressValue((lineno = 55, colno = 13, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["ugc-comment-count",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core"),"params": [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "displayTile")),"comments")),"length")]})])), env.opts.autoescape);
output += "\n        </span>\n    ";
;
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/ugc-expanded-tile.j2"] , dependencies)